/**
 * <s-scroll-reveal> — reveals every .dert-reveal element as it enters the viewport.
 * Content stays visible if this script never runs; hiding only applies once the
 * element sets data-ready on itself.
 */
class SScrollReveal extends HTMLElement {
  #observer;

  connectedCallback() {
    if (!('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-revealed', '');
          this.#observer.unobserve(entry.target);
        }
      }
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

    const targets = document.querySelectorAll('.dert-reveal');
    targets.forEach((target) => this.#observer.observe(target));
    this.setAttribute('data-ready', '');
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-scroll-reveal')) customElements.define('s-scroll-reveal', SScrollReveal);
